



























































































































import { Component, Vue } from 'vue-property-decorator';
import { progress } from '@/script/progress';
import {採用品要約型, 採用品検索条件型, 採用品一括登録結果型, 採用品検索条件型バリデータ一覧, 採用品検索結果型} from '@/type/master/item';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import ItemExcel from '@/views/master/form/import/ItemExcel.vue';
import {ValidationResult} from '@/type/validation/result';
import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';
import UsageClassSelector from '@/components/item/UsageClassSelector.vue';
import moment from 'moment';

@Component({
  components: {
    CompleteDialog,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    ItemExcel,
    UsageClassSelector,
  },
})
export default class ImportItem extends Vue {

  private アラートメッセージ: string | string[] | null = null;

  private 採用品検索条件: 採用品検索条件型 = this.検索条件初期値;

  private バリデータ: ValidationResult = new ValidationResult(採用品検索条件型バリデータ一覧);

  private 採用品一覧: 採用品要約型[] = [];
  private 該当件数: number = 0;

  private 取込結果一覧: 採用品一括登録結果型[] = [];
  private 取込エラー件数: number = 0;

  private 取込結果: boolean = false;

  private 選択行番号: number | null = null;

  private modal: boolean = false;

  private beforeUpdate() {
    this.バリデータ.validate(this.採用品検索条件);
  }

  private async search() {
    if (this.バリデータ.hasErrors) {
      this.アラートを表示する(this.バリデータ.getMessages());
      return;
    }

    await progress(this.検索する);
  }

  private async openForm() {
    this.modal = true;
  }

  private async importAfter(data: any) {
    this.modal = false;
    this.取込結果一覧 = data;
    this.取込エラー件数 = this.取込結果一覧.length;
    this.取込結果 = true;

    this.アラートメッセージ = null;
    this.ダイアログを開く('採用品Excel取込完了ダイアログ');
  }

  private async closeForm() {
    this.modal = false;
  }

  private async downloadList() {
    this.ダイアログを開く('Excelダウンロード確認ダイアログ');
  }

  private async 検索する(): Promise<void> {
    await api.採用品一括登録用一覧を検索する(this.採用品検索条件).then(
        this.検索結果を反映する,
        this.サーバリクエストエラートラップ);
  }

  private async 一覧をダウンロードする(): Promise<void> {
    this.ダイアログを閉じる('Excelダウンロード確認ダイアログ');
    const now = new Date();
    await download.採用品一括登録用一覧表を出力する(
      '採用品一括更新_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx'
      , this.採用品検索条件);
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  get 検索条件初期値(): 採用品検索条件型 {
    return {
      商品名カナ検索文字列: '',
      メーカー名カナ検索文字列: '',
      商品区分: '指定なし',
      使用区分: null,
      ソート区分: '商品名カナ',
      採用品管理対象外検索区分: '管理対象外を含まない',
    };
  }

  get 取込結果表示(): boolean {
    return this.取込結果;
  }

  get 採用品一覧表示(): boolean {
    return !this.取込結果;
  }

  private 行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  private 行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  private アラートを表示する(メッセージ: string | string[]) {
    this.アラートメッセージ = メッセージ;
    this.$modal.show('採用品Excel取込アラートダイアログ');
  }

  private 検索結果を反映する(検索結果: 採用品検索結果型) {
    this.採用品一覧 = 検索結果.採用品検索結果一覧;
    this.該当件数 = 検索結果.採用品検索結果一覧.length;
    this.取込結果 = false;
    if (this.該当件数 === 0) {
      this.アラートを表示する('検索結果が0件です。');
    }
    if (検索結果.アラートメッセージ) {
      this.アラートを表示する(検索結果.アラートメッセージ);
      return;
    }
  }

  private サーバリクエストエラートラップ(error: any) {
    if (!error) {
      this.アラートを表示する('エラーが発生しました。');
      return;
    }
    if (!error.status) {
      this.アラートを表示する('通信に失敗しました。');
      return;
    }
    if (error.status < 400 || error.status >= 500) {
      this.アラートを表示する('サーバーでエラーが発生しました。');
      return;
    }
    if (!error.data) {
      this.アラートを表示する('サーバーでエラーが発生しました。');
      return;
    }
    if (error.data.errors) {
      const メッセージ = error.data.errors.join('\n');
      this.アラートを表示する(メッセージ);
      return;
    }
    if (error.data.message) {
      this.アラートを表示する(error.data.message);
      return;
    }
    this.アラートを表示する('エラーが発生しました。');
  }
}
